"use strict";

APP.scenes.GameScene = function () {

    // Invoke (needed)
    EHDI.aka.Container.call(this);

    // ** Properties

    // ** Parent (This reference)
    var _parent = this;

    // ** Object References
    var _objLevel;

    // ** Graphics
    var _uiScore, _uiTimer, _btnPause;

    // Private Methods

    // ** General Methods

    // ** Handler
    var _handlerLevel_end = function (e) {

    };

    var _handlerLevel_start = function (e) {

    };

    var _handlerLevel_updatedScore = function (e) {

        if (!e) return;
        if (!e.score) return;

        if (!_uiScore) return;

        var diffScore = e.score - _uiScore.value;

        _uiScore.setScore(diffScore, true);
    };

    var _handlerTimer_tick = function () {
        if (_btnPause.isPaused === true || _btnPause.isEndGame === true)
            return;


        if (window.document.webkitHidden || window.document.hidden)
            return;

        if (_objLevel) _objLevel.check();
    };

    var _handler_timerComplete = function () {

        console.log('timer complete');
        // Pause elements
        if (_btnPause) _btnPause.endGame();

        // Save score to shared object
        if (_objLevel) {

            // Pause game
            if (typeof _objLevel.score === "number") {

                // if ( typeof APP.SBData.highscore === "undefined" ) APP.SBData.highscore = 0;

                // if ( _objLevel.score > APP.SBData.highscore ) {

                //     // APP.save.highscore = _objLevel.score;
                //     APP.SBData.highScore = _objLevel.score;
                //     // Main.SB.saveGameData( APP.save );
                //     Main.SB.saveGameData(APP.SBData, "DEFAULT", function(){
                //         console.log("data saved.");
                //     });
                // }

                APP.managers.storage.setLocalInfo(APP.config.id, APP.save);

                APP.scenes.GameScene.endGame();
                // Main.SB.end(score);
            }
        }

        // Show end popup here
    };

    /**
     * Handler for frame update
     * @param {Number} p_delta
     */
    var _handler_frameUpdate = function (p_delta) {

        if (_btnPause) {

            if (_btnPause.isPaused === true || _btnPause.isEndGame === true) {

                if (_objLevel) {
                    if (_objLevel.paused === false) _objLevel.paused = true;
                }

                if (_uiScore) {
                    if (_uiScore.paused === false) _uiScore.paused = true;
                }

                if (_uiTimer) {
                    if (_uiTimer.paused === false) _uiTimer.paused = true;
                }
            }
            else if (_btnPause.isPaused === false) {
                dragonBones.WorldClock.clock.advanceTime(p_delta * 0.001);

                if (_objLevel) {
                    if (_objLevel.paused === true) _objLevel.paused = false;
                }

                if (_uiScore) {
                    if (_uiScore.paused === true) _uiScore.paused = false;
                }

                if (_uiTimer) {
                    if (_uiTimer.paused === true) _uiTimer.paused = false;
                }
            }
        }
    };

    // ** Initialization Methods
    var _initProps = function () {

    };

    var _initGraphics = function () {

        if (!_objLevel) {

            _objLevel = new APP.game.LevelObject();

            if (_parent) _parent.addChild(_objLevel);
        }

        if (!_btnPause) {

            _btnPause = new EHDI.components.PauseButton();

            if (_parent) _parent.addChild(_btnPause);
        }

        if (!_uiTimer) {

            _uiTimer = new APP.ui.TimerUI(APP.ui.TimerType.COUNTDOWN, APP.game.LevelConfig.GAME_TIME, _handler_timerComplete, _handlerTimer_tick);

            _uiTimer.position.set(15, 15);

            if (_parent) _parent.addChild(_uiTimer);
        }

        if (!_uiScore) {

            _uiScore = new APP.ui.ScoreUI(APP.ui.ScoreType.SCORE, 0);

            _uiScore.position.set(_uiTimer.x + _uiTimer.width + 10, 15);

            if (_parent) _parent.addChild(_uiScore);
        }
    };

    var _initListeners = function () {

        // Add frame listeners
        APP.managers.update.addFrameListener(_handler_frameUpdate);

        // Initialize satellite listeners
        APP.managers.event.addListener(APP.game.LevelEvent.START, _handlerLevel_start);
        APP.managers.event.addListener(APP.game.LevelEvent.END, _handlerLevel_end);
        APP.managers.event.addListener(APP.game.LevelEvent.UPDATED_SCORE, _handlerLevel_updatedScore);
    };

    // ** Initialization Methods
    var _killProps = function () {

    };

    var _killGraphics = function () {

        if (_btnPause) {

            if (_btnPause.parent) _btnPause.parent.removeChild(_btnPause);
            _btnPause.destroy({ children: true });
        }
        _btnPause = null;

        if (_objLevel) {

            if (_objLevel.parent) _objLevel.parent.removeChild(_objLevel);

            _objLevel.destroy({ children: true });
        }
        _objLevel = null;

        if (_uiTimer) {

            if (_uiTimer.parent) _uiTimer.parent.removeChild(_uiTimer);

            _uiTimer.destroy({ children: true });
        }
        _uiTimer = null;

        if (_uiScore) {

            if (_uiScore.parent) _uiScore.parent.removeChild(_uiScore);

            _uiScore.destroy({ children: true });
        }
        _uiScore = null;
    };

    var _killListeners = function () {

        // Add frame listeners
        APP.managers.update.removeFrameListener(_handler_frameUpdate);

        // Remove satellite listeners
        APP.managers.event.removeListener(APP.game.LevelEvent.START, _handlerLevel_start);
        APP.managers.event.removeListener(APP.game.LevelEvent.END, _handlerLevel_end);
        APP.managers.event.removeListener(APP.game.LevelEvent.UPDATED_SCORE, _handlerLevel_updatedScore);
    };

    // Public Methods

    // ** Scene Methods
    this.screenWillAppear = function () {
        EHDI.DBoneFactory.enableClock = false;
    };

    this.screenDidAppear = function () {

        if (APP.save.isFirstTimePlay)
        //    if(APP.SBData.isFirstTimePlay)
        {
            APP.save.isFirstTimePlay = false;
            //            APP.SBData.isFirstTimePlay = false;
            APP.managers.storage.setLocalInfo(APP.config.id, APP.save);
            //            Main.SB.saveGameData(APP.SBData, "DEFAULT", function(){
            //                console.log("data saved.");
            //            });
            _btnPause.pauseGame();
        }
    };

    this.screenWillDisappear = function () {


    };

    this.screenDidDisappear = function () {

        this.destroy({ children: true });
    };

    this.destroy = function () {

        // Kill listeners
        _killListeners();

        // Kill graphics
        _killGraphics();

        // Kill props
        _killProps();

        // Call superclass method
        if (APP.scenes.Gamescenes) APP.scenes.GameScene.prototype.destroy.apply(this, arguments);
    };

    APP.scenes.GameScene.restart = function () {

        // Kill listeners
        _killListeners();
        // Kill graphics
        _killGraphics();
        // Kill props
        _killProps();

        _initProps();
        _initGraphics();
        _initListeners();
        APP.pauseButton = _btnPause;
        APP.gameOverCall = _handler_timerComplete;
        APP.gameInstance = _objLevel;
        // Return parent
        return _parent;
    }

    APP.scenes.GameScene.endGame = function () {

        if (EHDI.GAME.constants.gameEndFunction) {
            EHDI.GAME.constants.gameEndFunction(_objLevel.score);
        }
        else {
            // Compute rating
            var rating = 0;

            for (var i = 0; i < APP.game.LevelConfig.RATINGS.length; i++) {

                var ratingScore = APP.game.LevelConfig.RATINGS[i];

                if (_objLevel.score >= ratingScore) rating += 1;
            }
            // Push popup
            APP.managers.scene.pushPopUp(new APP.popups.EndPopup(_objLevel.score, rating), { y: new EHDI.scene.TransitionParameter(-APP.config.stageHeight, APP.config.stageHeight * 0.5), duration: 0.25 });

        }
    }

    // Call init methods
    _initProps();
    _initGraphics();
    _initListeners();

    APP.pauseButton = _btnPause;
    APP.gameOverCall = _handler_timerComplete;
    APP.gameInstance = _objLevel;
    // Return parent
    return _parent;
};
APP.scenes.GameScene.prototype = Object.create(EHDI.aka.Container.prototype);
APP.scenes.GameScene.prototype.constructor = APP.scenes.GameScene;
